import { resolveInTimeout } from './resolve-in-timeout';

export const racePromiseWithTimeout = <T>(promise: Promise<T>, timeoutMs: number) => {
  return new Promise<T>((resolve, reject) =>
    Promise.race([promise, resolveInTimeout(timeoutMs)]).then((value: any) => {
      if (value && value.finished) {
        console.info('timeout exceeds');
        return reject({ timeout: true });
      }
      resolve(value);
    })
  );
};
